module.exports = __webpack_public_path__ + "img/logo-circle.0b4f9b26.svg";